import React, { useEffect, useState, useMemo } from 'react';
import { Flex, Text, Button, Image } from 'rebass';
import { IoMdCheckmark } from "react-icons/io";
import defaultPhotoPreview from '../assets/Default_PreviewPhoto-Rounded.png'
import backToBfy from './assets/back-to-bfy.png'
import useEntity from 'entities/hooks/use-entity';
import Wrapper from './Wrapper';
import { getPublicChildJournal } from 'child-journals/api';
import useMatch from 'app/hooks/match';
import useHistory from 'app/hooks/history';
// import Loading from 'app/loading/index';

const TellAStorySuccess = () => {
    const {
        params: { id },
    } = useMatch();
    const { push } = useHistory();

    const { story } = useEntity({ type: 'stories', id });
    const memoirDetailId = story?.['journal-ids']?.[0]
    const [member, setMember] = useState(null)
    const isFromMarcom = sessionStorage.getItem('fromMarcom') === 'true'
    const [imageDetails, setImageDetails] = useState(null)

    const getMemoirDetails = async (memoirDetailId) => {
        const response = await getPublicChildJournal(memoirDetailId);
        const { relationships } = response?.data?.initial?.data
        const image = response?.data?.initial?.included.find(({ id, type }) => id === relationships?.['subject-avatar']?.data?.id && type === relationships?.['subject-avatar']?.data?.type)

        if (image?.relationships?.['canvas-image']?.data) {
            const canvasImageDetails = image?.relationships?.['canvas-image']?.data
            setImageDetails(response.data?.initial?.included.find(({ id, type }) => id === canvasImageDetails?.id && type === canvasImageDetails?.type))
        }
        else
            setImageDetails(image)
        if (response.data?.initial?.included?.length) {
            setMember(response.data?.initial?.included.find(({ type }) => type === "members")?.attributes)
        }
    }

    useEffect(() => {
        if (memoirDetailId)
            getMemoirDetails(memoirDetailId)
    }, [memoirDetailId])

    const subjectName = member?.['first-name']

    const imageUrl = useMemo(
        () => imageDetails?.attributes?.['image-versions'][8].url || defaultPhotoPreview,
        [imageDetails]
    );

    return <Wrapper p={2} justifyContent="center" alignItems="center">
        <Image
            src={imageUrl}
            minHeight={150}
            minWidth={150}
            height={150}
            width={150}
            maxWidth="150px"
            sx={{ borderRadius: '50%', objectFit: 'cover' }}
            loading="lazy"
        />
        {isFromMarcom ?
            <Flex mt='20px' justifyContent="center" alignItems="center" flexDirection="column">
                <Text
                    color="codGrey"
                    fontFamily="Bitter"
                    fontSize="30px"
                    fontStyle="normal"
                    fontWeight={600}
                    lineHeight="120%"
                    letterSpacing="-0.18px"
                    textAlign="center"
                >
                    Awesome! Simple, wasn’t it?&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                        <path d="M19.95 15.75C19.95 14.757 20.757 13.95 21.75 13.95C22.743 13.95 23.55 14.757 23.55 15.75C23.55 16.743 22.743 17.55 21.75 17.55C20.757 17.55 19.95 16.743 19.95 15.75ZM14.25 17.55C15.243 17.55 16.05 16.743 16.05 15.75C16.05 14.757 15.243 13.95 14.25 13.95C13.257 13.95 12.45 14.757 12.45 15.75C12.45 16.743 13.257 17.55 14.25 17.55ZM23.208 20.202C23.0205 20.385 18.5475 24.666 12.6915 20.112C12.1965 19.7295 11.4915 19.821 11.112 20.3085C10.7295 20.799 10.8195 21.507 11.3085 21.888C13.7775 23.808 16.086 24.4515 18.0705 24.4515C22.071 24.4515 24.756 21.8355 24.795 21.795C25.233 21.357 25.233 20.649 24.795 20.2095C24.3585 19.7685 23.6475 19.7625 23.205 20.2005L23.208 20.202ZM32.625 18C32.625 26.064 26.064 32.625 18 32.625C9.936 32.625 3.375 26.064 3.375 18C3.375 9.936 9.936 3.375 18 3.375C26.064 3.375 32.625 9.936 32.625 18ZM30.375 18C30.375 11.1765 24.8235 5.625 18 5.625C11.1765 5.625 5.625 11.1765 5.625 18C5.625 24.8235 11.1765 30.375 18 30.375C24.8235 30.375 30.375 24.8235 30.375 18Z" fill="#0E0E0E" />
                    </svg>
                </Text>
                <Text
                    mt={2}
                    color="#64748B"
                    fontFamily="Poppins"
                    fontSize="18px"
                    fontStyle="normal"
                    fontWeight={400}
                    lineHeight="165%"
                    textAlign="center"
                >
                    Ready to start your own Baby Yearbook?
                </Text>
            </Flex>
            :
            <Flex mt='20px' justifyContent="center" alignItems="center" flexDirection="column">
                <Text
                    color="codGrey"
                    fontFamily="Bitter"
                    fontSize="30px"
                    fontStyle="normal"
                    fontWeight={600}
                    lineHeight="120%"
                    letterSpacing="-0.18px"
                >
                    Awesome! All Done&nbsp;
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                        <path d="M19.95 15.75C19.95 14.757 20.757 13.95 21.75 13.95C22.743 13.95 23.55 14.757 23.55 15.75C23.55 16.743 22.743 17.55 21.75 17.55C20.757 17.55 19.95 16.743 19.95 15.75ZM14.25 17.55C15.243 17.55 16.05 16.743 16.05 15.75C16.05 14.757 15.243 13.95 14.25 13.95C13.257 13.95 12.45 14.757 12.45 15.75C12.45 16.743 13.257 17.55 14.25 17.55ZM23.208 20.202C23.0205 20.385 18.5475 24.666 12.6915 20.112C12.1965 19.7295 11.4915 19.821 11.112 20.3085C10.7295 20.799 10.8195 21.507 11.3085 21.888C13.7775 23.808 16.086 24.4515 18.0705 24.4515C22.071 24.4515 24.756 21.8355 24.795 21.795C25.233 21.357 25.233 20.649 24.795 20.2095C24.3585 19.7685 23.6475 19.7625 23.205 20.2005L23.208 20.202ZM32.625 18C32.625 26.064 26.064 32.625 18 32.625C9.936 32.625 3.375 26.064 3.375 18C3.375 9.936 9.936 3.375 18 3.375C26.064 3.375 32.625 9.936 32.625 18ZM30.375 18C30.375 11.1765 24.8235 5.625 18 5.625C11.1765 5.625 5.625 11.1765 5.625 18C5.625 24.8235 11.1765 30.375 18 30.375C24.8235 30.375 30.375 24.8235 30.375 18Z" fill="#0E0E0E" />
                    </svg>
                </Text>
            </Flex>
        }


        {isFromMarcom ?
            <Flex flexDirection="column" alignItems="center" justifyContent="center" mt={5}>
                <Button
                    width={200}
                    sx={{ borderRadius: '23px' }}
                    onClick={() => push('/babys-first-year/get-started?step=1')} height="44px" my="auto" py="unset">
                    Start for My Baby
                </Button>
                <Button
                    width={200}
                    sx={{
                        borderRadius: '23px',
                        border: '1.5px solid #9B59B6',
                        color: '#9B59B6'
                    }}
                    bg="transparent"
                    onClick={() => push('/gift?step=1')} height="44px" my={3} py="unset">
                    Give as a Gift
                </Button>

                <Image src={backToBfy} my={6} width={280} sx={{ cursor: 'pointer' }}
                    onClick={() => window.location.href = 'https://babyyearbooks.com/'}
                />
            </Flex>
            : <Flex
                mt={3}
                px="15px"
                py={1}
                sx={{
                    borderRadius: "30px",
                    background: "#E0FFEA"
                }}
            >
                <IoMdCheckmark color="#00611F" size={24} />
                <Text
                    ml={1}
                    color="#00611F"
                    fontFamily="Poppins"
                    fontSize="16px"
                    fontStyle="normal"
                    fontWeight={500}
                    lineHeight="150%"
                    letterSpacing="-0.32px"
                > Your story has been sent to {subjectName}
                </Text>
            </Flex>}
    </Wrapper>

};

export default TellAStorySuccess;
